import { api } from "./api";

// Llamadas a la API de administradores de staff (agency_admin/master),
// compartidas entre Admin.jsx (crea/gestiona los de su propia agencia,
// implícita en el JWT) y MasterAgencies.jsx (el master crea/gestiona los de
// cualquier agencia, con agency_id explícito) — antes cada página repetía
// la misma URL y forma de llamada por separado.

export async function createAdmin(fields) {
  const { data } = await api.post("/admin/admins", fields);
  return data;
}

export async function setAdminActive(bookingId, active) {
  await api.patch(`/admin/admins/${bookingId}`, { active });
}

export async function regenerateAdminPassword(bookingId) {
  const { data } = await api.post(`/admin/admins/${bookingId}/regenerate-password`);
  return data;
}
